/* =============================================================================
   CONTROL V2 SPANISH - LIVE ORDERS JS
   JavaScript para el popup de órdenes en vivo
   No Liquid dependencies - safe for external JS file
   ============================================================================= */

// Array of sample orders
const orders = [
  { name: "Sandra", location: "HI", product: "NAD3® 60 - 1 Bottle", time: "Just now" },
  { name: "Nikki", location: "CA", product: "NAD3® 60 - 1 Bottle", time: "2 minutes ago" },
  { name: "Roland", location: "TX", product: "NAD3® 60 - 1 Bottle", time: "5 minutes ago" },
  { name: "Susan", location: "OH", product: "NAD3® 60 - 1 Bottle", time: "8 minutes ago" },
  { name: "Sofia", location: "FL", product: "NAD3® 60 - 1 Bottle", time: "10 minutes ago" },
  { name: "Lidia", location: "GA", product: "NAD3® 60 - 1 Bottle", time: "12 minutes ago" },
  { name: "Norma", location: "IL", product: "NAD3® 60 - 3 Bottles", time: "15 minutes ago" },
  { name: "Kenneth", location: "GA", product: "NAD3® 60 - 1 Bottle", time: "18 minutes ago" },
  { name: "Vickey", location: "NY", product: "NAD3® 60 - 1 Bottle", time: "20 minutes ago" },
  { name: "Stacy", location: "IL", product: "NAD3® 60 - 3 Bottles", time: "25 minutes ago" },
  { name: "Anthea", location: "NY", product: "NAD3® 60 - 2 Bottles", time: "30 minutes ago" },
  { name: "Norma", location: "NV", product: "NAD3® 60 - 3 Bottles", time: "35 minutes ago" },
  { name: "Tina", location: "AL", product: "NAD3® 60 - 1 Bottle", time: "40 minutes ago" },
  { name: "Burt", location: "CA", product: "NAD3® 60 - 2 Bottles", time: "45 minutes ago" },
  { name: "Lorna", location: "WA", product: "NAD3® 60 - 1 Bottle", time: "50 minutes ago" },

  { name: "Maria", location: "GA", product: "NAD3® 60 - 3 Bottles", time: "Just now" },
  { name: "Kelly", location: "OH", product: "NAD3® 60 - 1 Bottle", time: "2 minutes ago" },
  { name: "Doris", location: "NM", product: "NAD3® 60 - 1 Bottle", time: "5 minutes ago" },
  { name: "Thao", location: "TX", product: "NAD3® 60 - 3 Bottles", time: "8 minutes ago" },
  { name: "Andre", location: "TX", product: "NAD3® 60 - 1 Bottle", time: "10 minutes ago" },
  { name: "Tracy", location: "VT", product: "NAD3® 60 - 1 Bottle", time: "12 minutes ago" },
  { name: "Clint", location: "TX", product: "NAD3® 60 - 3 Bottles", time: "15 minutes ago" },
  { name: "Kathleen", location: "NY", product: "NAD3® 60 - 1 Bottle", time: "18 minutes ago" },
  { name: "Karen", location: "TX", product: "NAD3® 60 - 1 Bottle", time: "20 minutes ago" },
  { name: "Keepe", location: "NC", product: "NAD3® 60 - 3 Bottles", time: "25 minutes ago" },
  { name: "Jeff", location: "SC", product: "NAD3® 60 - 1 Bottle", time: "30 minutes ago" },
  { name: "Nathan", location: "AZ", product: "NAD3® 60 - 3 Bottles", time: "35 minutes ago" },
  { name: "Ranjit", location: "MI", product: "NAD3® 60 - 1 Bottle", time: "40 minutes ago" },
  { name: "Alejandro", location: "AR", product: "NAD3® 60 - 3 Bottles", time: "45 minutes ago" },
  { name: "John", location: "NE", product: "NAD3® 60 - 1 Bottles", time: "50 minutes ago" }
];

function toSpanishProduct(product) {
  return product
    .replace('NAD3® 60 - 1 Bottles', 'NAD3® 60 - 1 Botella')
    .replace('NAD3® 60 - 1 Bottle', 'NAD3® 60 - 1 Botella')
    .replace('NAD3® 60 - 2 Bottles', 'NAD3® 60 - 2 Botellas')
    .replace('NAD3® 60 - 3 Bottles', 'NAD3® 60 - 3 Botellas');
}

function toSpanishTime(time) {
  if (/^just now$/i.test(time.trim())) {
    return 'Recién';
  }

  const match = time.match(/^(\d+)\s+minutes?\s+ago$/i);
  if (match) {
    const minutes = Number(match[1]);
    return `Hace ${minutes} minuto${minutes === 1 ? '' : 's'}`;
  }

  return time;
}

// Display popup function
function showLiveOrder() {
  const randomOrder = orders[Math.floor(Math.random() * orders.length)];
  const popup = document.getElementById('live-orders-popup');
  const productText = toSpanishProduct(randomOrder.product);
  const timeText = toSpanishTime(randomOrder.time);
  
  if (!popup) return;
  
  popup.innerHTML = `
    <div class="klaviyo_form_trigger_lop">
      <div class="popup-content">
        <div class="popup-image">
          <img style="border-radius: 5px;" src="https://cdn.shopify.com/s/files/1/2443/2395/files/Amazon_NAD3_60ct_Page01.jpg?v=1733346589" alt="Product Image">
          <span class="glow-dot"></span>
        </div>
        <div class="popup-text">
          <div class="popup-line">
            <div class="name-location"><strong>${randomOrder.name} de ${randomOrder.location}</strong></div>
          </div>
          <div class="popup-line product-name"><span class="ordered-text">pidió</span> <strong><span class="product-text">${productText}</span></strong></div>
          <div class="popup-line order-time">${timeText}</div>
          <div class="verified-buyer-badge">Comprador verificado</div>
        </div>
      </div>
      <button class="save-extra-btn">OBTENÉ 10% EXTRA OFF</button>
    </div> 
  `;
  popup.style.display = 'block';

  // KLAVIYO
  const button = document.querySelector('.klaviyo_form_trigger_lop');
  if (button) {
    button.addEventListener('click', function () {
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', 'X5iC5X']);
    });
  }

  setTimeout(() => {
    popup.classList.add('popup-hide');
  }, 6000); // Show for 6 seconds

  setTimeout(() => {
    popup.style.display = 'none';
    popup.classList.remove('popup-hide');
    setTimeout(showLiveOrder, getRandomTimeInterval());
  }, 6500);
}

// Random time intervals between popups
function getRandomTimeInterval() {
  const intervals = [20000, 20000, 20000]; 
  return intervals[Math.floor(Math.random() * intervals.length)];
}

// Start the popup display
document.addEventListener('DOMContentLoaded', () => {
  setTimeout(showLiveOrder, getRandomTimeInterval());
});
